import React from 'react';
import {View, StyleSheet } from '@react-pdf/renderer';
import InvoiceTableHeader from './InvoiceTableHeader'
import InvoiceTableRow from './InvoiceTableRow'
const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 10,
       // borderWidth: 1,
        // borderColor: '#000',
        // marginBottom: 10,
        // border: 1,
    },
});

  const InvoiceItemsTable = ({invoice}) => (
   
    <View style={styles.tableContainer}>
        {/* <InvoiceTableHeader /> */}
        <InvoiceTableRow items={invoice} />
    </View>
  );
  
  export default InvoiceItemsTable